import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { FooterProps } from "./types";
import {
  // PropertyMappingType,
  PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { getMenuDefinitions } from 'components/cms/definitions';

export class FooterDefinitions extends CmsReactComponent<FooterProps> {
  static defaultProps = {};

  static schemaName = "footer";
  static schemaType = "navigation-component";

  static propertyDefinitions: PropertyDefinition[] = [
    ...getMenuDefinitions("menu1", "1. Menü"),
    ...getMenuDefinitions("menu2", "2. Menü"),
    ...getMenuDefinitions("menu3", "3. Menü"),
    ...getMenuDefinitions("menu4", "4. Menü"),
    {
      name: "contact",
      text: "İletişim Bilgileri",
      mapping: {
        type: PropertyMappingType.Html
      }
    },
  ];
}

